module.exports = __webpack_public_path__ + "static/media/time-session-15.cc20c68d.svg";